import React from "react";
import locale from "@bonliva-crm/locale";
import { PersonAddIcon, useSnackbarsPipeline } from "@bonliva-crm/ui";
import { IconButton } from "@material-ui/core";
import { Item } from "./item";
import { useSetConsultantResponsiblePersonMutation } from "@bonliva-crm/graphql";

type Props = {
  responsiblePerson?: { Name: string };
  consultantId: string;
};

export function ResponsiblePersonItem({ responsiblePerson, consultantId }: Props) {
  const snack = useSnackbarsPipeline();
  const [setResponsiblePerson, { loading }] = useSetConsultantResponsiblePersonMutation();

  const value = responsiblePerson ? (
    responsiblePerson.Name
  ) : (
    <IconButton
      disabled={loading}
      style={{
        verticalAlign: "bottom",
        marginRight: "4px",
        padding: 0
      }}
      onClick={() => {
        setResponsiblePerson({
          variables: {
            consultantId
          }
        })
          .then(() => {
            snack.showSuccess(locale.consultantAssigned);
          })
          .catch((e) => {
            snack.showError(locale.somethingWentWrong);
            console.error(e);
          });
      }}
    >
      <PersonAddIcon color="primary" />
    </IconButton>
  );

  return <Item value={value} title={locale["Responsible HBA"]} />;
}
